import { IpaginatedSeccionfinanzas, ISeccionfinanzasItem } from '../models'

export enum SeccionfinanzasActionTypes {
  SEARCH_SECCIONFINANZAS = 'seccionfinanzas/search',
  SEARCHING_SECCIONFINANZAS = 'seccionfinanzas/searching',
  FOUND_SECCIONFINANZAS = 'seccionfinanzas/found',
  SEARCHING_SECCIONFINANZAS_FAILED = 'seccionfinanzas/searching_failed',

  LOAD_SECCIONFINANZAS = 'seccionfinanzas/load',
  LOADING_SECCIONFINANZAS = 'seccionfinanzas/loading',
  LOADED_SECCIONFINANZAS = 'seccionfinanzas/loaded',
  LOADING_SECCIONFINANZAS_FAILED = 'seccionfinanzas/loading_failed',

  ADD_SECCIONFINANZAS = 'seccionfinanzas/add',
  ADDING_SECCIONFINANZAS = 'seccionfinanzas/adding',
  ADDED_SECCIONFINANZAS = 'seccionfinanzas/added',
  ADDING_SECCIONFINANZAS_FAILED = 'seccionfinanzas/adding_failed',

  REMOVE_SECCIONFINANZA = 'seccionfinanzas/remove',
  REMOVING_SECCIONFINANZA = 'seccionfinanzas/removing',
  REMOVED_SECCIONFINANZA = 'seccionfinanzas/removed',
  REMOVING_SECCIONFINANZA_FAILED = 'seccionfinanzas/removing_failed',

  SOFT_REMOVE_SECCIONFINANZAS = 'seccionfinanzas/soft_remove',
  SOFT_REMOVING_SECCIONFINANZAS = 'seccionfinanzas/soft_removing',
  SOFT_REMOVED_SECCIONFINANZAS = 'seccionfinanzas/soft_removed',
  SOFT_REMOVING_SECCIONFINANZAS_FAILED = 'seccionfinanzas/soft_removing_failed',

  EDIT_SECCIONFINANZAS = 'seccionfinanzas/edit',
  EDITING_SECCIONFINANZAS = 'seccionfinanzas/editing',
  EDITED_SECCIONFINANZAS = 'seccionfinanzas/edited',
  EDITING_SECCIONFINANZAS_FAILED = 'seccionfinanzas/editing_failed',

  VIEW_SECCIONFINANZAS = 'seccionfinanzas/view',
  VIEWING_SECCIONFINANZAS = 'seccionfinanzas/viewing',
  VIEWED_SECCIONFINANZAS = 'seccionfinanzas/viewed',
  VIEWING_SECCIONFINANZAS_FAILED = 'seccionfinanzas/viewing_failed',
}

export function searchSeccionfinanzas(searchOptions: TSearchOptions | string, keep?: boolean): ISearchSeccionfinanzasAction {
  return {
    type: SeccionfinanzasActionTypes.SEARCH_SECCIONFINANZAS,
    searchOptions: typeof searchOptions === 'string' ? { searchString: searchOptions } : searchOptions,
    keep: keep,
  }
}

export function searchingSeccionfinanzas(): ISearchingSeccionfinanzasAction {
  return {
    type: SeccionfinanzasActionTypes.SEARCHING_SECCIONFINANZAS,
  }
}

export function foundSeccionfinanzas(seccionfinanzas: IpaginatedSeccionfinanzas, keep?: boolean): IFoundSeccionfinanzasAction {
  return {
    type: SeccionfinanzasActionTypes.FOUND_SECCIONFINANZAS,
    keep: keep,
    payload: {
      seccionfinanzas,
    },
  }
}

export function searchingSeccionfinanzasFailed(): ISearchingSeccionfinanzasFailedAction {
  return {
    type: SeccionfinanzasActionTypes.SEARCHING_SECCIONFINANZAS_FAILED,
  }
}

export function loadSeccionfinanzas(loadOptions: TSearchOptions): ILoadSeccionfinanzasAction {
  return {
    type: SeccionfinanzasActionTypes.LOAD_SECCIONFINANZAS,
    loadOptions: loadOptions,
  }
}

export function loadingSeccionfinanzas(): ILoadingSeccionfinanzasAction {
  return {
    type: SeccionfinanzasActionTypes.LOADING_SECCIONFINANZAS,
  }
}

export function loadedSeccionfinanzas(seccionfinanzas: IpaginatedSeccionfinanzas): ILoadedSeccionfinanzasAction {
  return {
    type: SeccionfinanzasActionTypes.LOADED_SECCIONFINANZAS,
    payload: {
      seccionfinanzas,
    },
  }
}

export function loadingSeccionfinanzasFailed(): ILoadingSeccionfinanzasFailedAction {
  return {
    type: SeccionfinanzasActionTypes.LOADING_SECCIONFINANZAS_FAILED,
  }
}

export function addSeccionfinanzas(seccionfinanza: ISeccionfinanzasItem): IAddSeccionfinanzasAction {
  return {
    type: SeccionfinanzasActionTypes.ADD_SECCIONFINANZAS,
    payload: seccionfinanza,
  }
}

export function addingSeccionfinanzas(): IAddingSeccionfinanzasAction {
  return {
    type: SeccionfinanzasActionTypes.ADDING_SECCIONFINANZAS,
  }
}

export function addedSeccionfinanzas(seccionfinanzas: IpaginatedSeccionfinanzas): IAddedSeccionfinanzasAction {
  return {
    type: SeccionfinanzasActionTypes.ADDED_SECCIONFINANZAS,
    payload: {
      seccionfinanzas,
    },
  }
}

export function addingSeccionfinanzasFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): IAddingSeccionfinanzasFailedAction {
  return {
    type: SeccionfinanzasActionTypes.ADDING_SECCIONFINANZAS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function removeSeccionfinanza(seccionfinanza: ISeccionfinanzasItem): IRemoveSeccionfinanzaAction {
  return {
    type: SeccionfinanzasActionTypes.REMOVE_SECCIONFINANZA,
    payload: seccionfinanza,
  }
}

export function removingSeccionfinanza(): IRemovingSeccionfinanzaAction {
  return {
    type: SeccionfinanzasActionTypes.REMOVING_SECCIONFINANZA,
  }
}

export function removedSeccionfinanza(): IRemovedSeccionfinanzaAction {
  return {
    type: SeccionfinanzasActionTypes.REMOVED_SECCIONFINANZA,
  }
}

export function removingSeccionfinanzaFailed(): IRemovingSeccionfinanzaFailedAction {
  return {
    type: SeccionfinanzasActionTypes.REMOVING_SECCIONFINANZA_FAILED,
  }
}

export function softRemoveSeccionfinanzas(seccionfinanza: ISeccionfinanzasItem): ISoftRemoveSeccionfinanzasAction {
  return {
    type: SeccionfinanzasActionTypes.SOFT_REMOVE_SECCIONFINANZAS,
    payload: seccionfinanza,
  }
}

export function softRemovingSeccionfinanzas(): ISoftRemovingSeccionfinanzasAction {
  return {
    type: SeccionfinanzasActionTypes.SOFT_REMOVING_SECCIONFINANZAS,
  }
}

export function softRemovedSeccionfinanzas(seccionfinanza: ISeccionfinanzasItem): ISoftRemovedSeccionfinanzasAction {
  return {
    type: SeccionfinanzasActionTypes.SOFT_REMOVED_SECCIONFINANZAS,
    payload: seccionfinanza,
  }
}

export function softRemovingSeccionfinanzasFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): ISoftRemovingSeccionfinanzasFailedAction {
  return {
    type: SeccionfinanzasActionTypes.SOFT_REMOVING_SECCIONFINANZAS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function editSeccionfinanzas(seccionfinanza: ISeccionfinanzasItem): IEditSeccionfinanzasAction {
  return {
    type: SeccionfinanzasActionTypes.EDIT_SECCIONFINANZAS,
    payload: seccionfinanza,
  }
}

export function editingSeccionfinanzas(): IEditingSeccionfinanzasAction {
  return {
    type: SeccionfinanzasActionTypes.EDITING_SECCIONFINANZAS,
  }
}

export function editedSeccionfinanzas(seccionfinanzas: ISeccionfinanzasItem): IEditedSeccionfinanzasAction {
  return {
    type: SeccionfinanzasActionTypes.EDITED_SECCIONFINANZAS,
    payload: seccionfinanzas,
  }
}

export function editingSeccionfinanzasFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): IEditingSeccionfinanzasFailedAction {
  return {
    type: SeccionfinanzasActionTypes.EDITING_SECCIONFINANZAS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function viewSeccionfinanzas(seccionfinanza: ISeccionfinanzasItem): IViewSeccionfinanzasAction {
  return {
    type: SeccionfinanzasActionTypes.VIEW_SECCIONFINANZAS,
    payload: seccionfinanza,
  }
}

export function viewingSeccionfinanzas(): IViewingSeccionfinanzasAction {
  return {
    type: SeccionfinanzasActionTypes.VIEWING_SECCIONFINANZAS,
  }
}

export function viewedSeccionfinanzas(seccionfinanzas: ISeccionfinanzasItem): IViewedSeccionfinanzasAction {
  return {
    type: SeccionfinanzasActionTypes.VIEWED_SECCIONFINANZAS,
    payload: seccionfinanzas,
  }
}

export function viewingSeccionfinanzasFailed(): IViewingSeccionfinanzasFailedAction {
  return {
    type: SeccionfinanzasActionTypes.VIEWING_SECCIONFINANZAS_FAILED,
  }
}

type TSearchOptions = {
  searchString?: string
  searchField?: string
  page?: number
  limit?: number
  populate?: boolean
  sort?: {
    field: string
    method?: 'asc' | 'desc'
  }
  filters?: { field: string; value: string }[]
}

export interface ISearchSeccionfinanzasAction {
  type: SeccionfinanzasActionTypes.SEARCH_SECCIONFINANZAS
  searchOptions: TSearchOptions
  keep?: boolean
}

export interface ISearchingSeccionfinanzasAction {
  type: SeccionfinanzasActionTypes.SEARCHING_SECCIONFINANZAS
}

export interface IFoundSeccionfinanzasAction {
  type: SeccionfinanzasActionTypes.FOUND_SECCIONFINANZAS
  keep?: boolean
  payload: {
    seccionfinanzas: IpaginatedSeccionfinanzas
  }
}

export interface ISearchingSeccionfinanzasFailedAction {
  type: SeccionfinanzasActionTypes.SEARCHING_SECCIONFINANZAS_FAILED
}

export interface ILoadSeccionfinanzasAction {
  type: SeccionfinanzasActionTypes.LOAD_SECCIONFINANZAS
  loadOptions: TSearchOptions
}

export interface ILoadingSeccionfinanzasAction {
  type: SeccionfinanzasActionTypes.LOADING_SECCIONFINANZAS
}

export interface ILoadedSeccionfinanzasAction {
  type: SeccionfinanzasActionTypes.LOADED_SECCIONFINANZAS
  payload: {
    seccionfinanzas: IpaginatedSeccionfinanzas
  }
}

export interface ILoadingSeccionfinanzasFailedAction {
  type: SeccionfinanzasActionTypes.LOADING_SECCIONFINANZAS_FAILED
}

export interface IAddSeccionfinanzasAction {
  type: SeccionfinanzasActionTypes.ADD_SECCIONFINANZAS
  payload: ISeccionfinanzasItem
}

export interface IAddingSeccionfinanzasAction {
  type: SeccionfinanzasActionTypes.ADDING_SECCIONFINANZAS
}

export interface IAddedSeccionfinanzasAction {
  type: SeccionfinanzasActionTypes.ADDED_SECCIONFINANZAS
  payload: {
    seccionfinanzas: IpaginatedSeccionfinanzas
  }
}

export interface IAddingSeccionfinanzasFailedAction {
  type: SeccionfinanzasActionTypes.ADDING_SECCIONFINANZAS_FAILED
  message: string
  status: number
  field?: string
}

export interface IRemoveSeccionfinanzaAction {
  type: SeccionfinanzasActionTypes.REMOVE_SECCIONFINANZA
  payload: ISeccionfinanzasItem
}

export interface IRemovingSeccionfinanzaAction {
  type: SeccionfinanzasActionTypes.REMOVING_SECCIONFINANZA
}

export interface IRemovedSeccionfinanzaAction {
  type: SeccionfinanzasActionTypes.REMOVED_SECCIONFINANZA
}

export interface IRemovingSeccionfinanzaFailedAction {
  type: SeccionfinanzasActionTypes.REMOVING_SECCIONFINANZA_FAILED
}

export interface ISoftRemoveSeccionfinanzasAction {
  type: SeccionfinanzasActionTypes.SOFT_REMOVE_SECCIONFINANZAS
  payload: ISeccionfinanzasItem
}

export interface ISoftRemovingSeccionfinanzasAction {
  type: SeccionfinanzasActionTypes.SOFT_REMOVING_SECCIONFINANZAS
}

export interface ISoftRemovedSeccionfinanzasAction {
  type: SeccionfinanzasActionTypes.SOFT_REMOVED_SECCIONFINANZAS
  payload: ISeccionfinanzasItem
}

export interface ISoftRemovingSeccionfinanzasFailedAction {
  type: SeccionfinanzasActionTypes.SOFT_REMOVING_SECCIONFINANZAS_FAILED
  message: string
  status: number
  field?: string
}

export interface IEditSeccionfinanzasAction {
  type: SeccionfinanzasActionTypes.EDIT_SECCIONFINANZAS
  payload: ISeccionfinanzasItem
}

export interface IEditingSeccionfinanzasAction {
  type: SeccionfinanzasActionTypes.EDITING_SECCIONFINANZAS
}

export interface IEditedSeccionfinanzasAction {
  type: SeccionfinanzasActionTypes.EDITED_SECCIONFINANZAS
  payload: ISeccionfinanzasItem
}

export interface IEditingSeccionfinanzasFailedAction {
  type: SeccionfinanzasActionTypes.EDITING_SECCIONFINANZAS_FAILED
  message: string
  status: number
  field?: string
}

export interface IViewSeccionfinanzasAction {
  type: SeccionfinanzasActionTypes.VIEW_SECCIONFINANZAS
  payload: ISeccionfinanzasItem
}

export interface IViewingSeccionfinanzasAction {
  type: SeccionfinanzasActionTypes.VIEWING_SECCIONFINANZAS
}

export interface IViewedSeccionfinanzasAction {
  type: SeccionfinanzasActionTypes.VIEWED_SECCIONFINANZAS
  payload: ISeccionfinanzasItem
}

export interface IViewingSeccionfinanzasFailedAction {
  type: SeccionfinanzasActionTypes.VIEWING_SECCIONFINANZAS_FAILED
}

export type SeccionfinanzasAction =
  | ISearchSeccionfinanzasAction
  | ISearchingSeccionfinanzasAction
  | IFoundSeccionfinanzasAction
  | ISearchingSeccionfinanzasFailedAction
  | ILoadSeccionfinanzasAction
  | ILoadingSeccionfinanzasAction
  | ILoadedSeccionfinanzasAction
  | ILoadingSeccionfinanzasFailedAction
  | IAddSeccionfinanzasAction
  | IAddingSeccionfinanzasAction
  | IAddedSeccionfinanzasAction
  | IAddingSeccionfinanzasFailedAction
  | IRemoveSeccionfinanzaAction
  | IRemovingSeccionfinanzaAction
  | IRemovedSeccionfinanzaAction
  | IRemovingSeccionfinanzaFailedAction
  | ISoftRemoveSeccionfinanzasAction
  | ISoftRemovingSeccionfinanzasAction
  | ISoftRemovedSeccionfinanzasAction
  | ISoftRemovingSeccionfinanzasFailedAction
  | IEditSeccionfinanzasAction
  | IEditingSeccionfinanzasAction
  | IEditedSeccionfinanzasAction
  | IEditingSeccionfinanzasFailedAction
  | IViewSeccionfinanzasAction
  | IViewingSeccionfinanzasAction
  | IViewedSeccionfinanzasAction
  | IViewingSeccionfinanzasFailedAction
